import { useEffect } from "react";

export const PageInformation = ({
    title,
    children
}) => {
    useEffect(() => {
        document.title = title;
    }, []);
    return children;
};

export default PageInformation;